/* 
  评卷历史统计
*/
import request from "@/utils/request";

//获取统计页面参数
export function getParam() {
  return request({
    url: "/markteacher/markHistoryStatistics/getParam",
    method: "get"
  });
}

//统计
export function getMarkHistoryStatistics(params) {
  return request({
    url: "/markteacher/markHistoryStatistics/getMarkHistoryStatistics",
    method: "get",
    params
  });
}